import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const stats = [
  { value: '2 000+', label: 'Spersonalizowanych emaili' },
  { value: '200+',   label: 'Agentów AI w n8n' },
  { value: '3+',     label: 'Pełnych systemów AIOS' },
];

export default function Stats() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <section className="bg-bg py-16 md:py-24 border-y border-stroke" ref={ref} aria-label="Wyniki w liczbach">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 divide-y md:divide-y-0 md:divide-x divide-stroke">
          {stats.map((stat, idx) => (
            <motion.div
              key={idx}
              className="flex flex-col items-center text-center pt-8 md:pt-0 first:pt-0"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.8, delay: 0.2 * idx, ease: "easeOut" }}
            >
              <div className="text-6xl md:text-7xl lg:text-[80px] font-display italic mb-4 bg-gradient-to-br from-text-primary to-muted bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-sm tracking-[0.2em] uppercase text-muted">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
